// Listens to the Rebuy add to cart event and ensures the side cart opens after product added.
// Second parameter is zero since PLPs, PDPs, and Rebuy widgets natively add to cart. This only triggers the cart to open.
document.addEventListener('rebuy:cart.add', (event) => { 
  if(window.eHS?.addToCart && event?.detail?.item?.variant_id){
    window.eHS.addToCart(event.detail.item.variant_id, 0);
  }
});

